export default "__VITE_ASSET__De3HEzMo__"